import { isMobile } from "@modules/util/device"
import { afterFilterApiFetched } from "../after-filter-api-fetched"
import { getFilterApiResult } from "../api"
import { advertCardsContainerElement, getShowResultsButton, getShowResultsButtonLocationModal } from "../dom"
import { loaderHtmlString } from "../filter"

export function setShowResultsButton(advertCount: number) {
    if (!isMobile()) {
        return
    }
    const resultsButton = getShowResultsButton()
    const resultsButtonLocation = getShowResultsButtonLocationModal()
    if (resultsButton) resultsButton.innerHTML = `${advertCount === 1 ? "Ein" : advertCount} Treffer anzeigen`
    if (resultsButtonLocation)
        resultsButtonLocation.innerHTML = `${advertCount === 1 ? "Ein" : advertCount} Treffer anzeigen`
}

export function setShowResultsButtonLoading() {
    if (!isMobile()) {
        return
    }
    const resultsButton = getShowResultsButton()
    const resultsButtonLocation = getShowResultsButtonLocationModal()
    if (resultsButton) resultsButton.innerHTML = loaderHtmlString()
    if (resultsButtonLocation) resultsButtonLocation.innerHTML = loaderHtmlString()
}

export async function handleShowResultsButtonClick() {
    const advertsCardsContainerEl = advertCardsContainerElement()
    if (advertsCardsContainerEl && getFilterApiResult()?.content) {
        advertsCardsContainerEl.innerHTML = getFilterApiResult()?.content || ""
        afterFilterApiFetched(getFilterApiResult())
    }
}

getShowResultsButton()?.addEventListener("click", handleShowResultsButtonClick)
setShowResultsButton(SearchConfig.advertCount)
